import { RootState } from 'store';
import { createSelector } from '@reduxjs/toolkit';

const selectPatientWhatsAppMessagesState = (state: RootState) => state.patientWhatsAppMessages;

export const selectPatientWhatsAppMessageList = createSelector(
  selectPatientWhatsAppMessagesState,
  ({ messages }) => {
    return messages;
  },
);

export const selectPatientWhatsAppMessageCurrent = createSelector(
  selectPatientWhatsAppMessageList,
  (list) => {
    return list.length ? list[0] : null;
  },
);
